import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
/**
 * 输入联想组件，继承Base
 * @module $ui/components/my-autocomplete
 */

import { Autocomplete } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MyAutocomplete',
  mixins: [Base],
  components: {
    Autocomplete: Autocomplete
  },
  props: {
    value: String
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var scopedSlots = this.$scopedSlots.default ? {
      default: function _default(props) {
        return _this.$scopedSlots.default(props);
      }
    } : null;
    var vnode = h(Autocomplete, _mergeJSXProps([{
      "ref": 'comp',
      "class": 'my-autocomplete'
    }, {
      props: this.innerProps,
      on: _objectSpread({}, this.$listeners),
      attrs: this.innerProps,
      scopedSlots: scopedSlots
    }, {
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    }]), [this.createSlots(['prefix', 'suffix', 'prepend', 'append'])]);
    return this.renderComponent(vnode);
  },
  mounted: function mounted() {
    this.extendMethods(this.$refs.comp, ['focus']);
  }
};